import React from 'react';
export function Returns() {
  return <section data-id="element-772">
      <h2 className="text-xl font-bold text-gray-900 uppercase mb-4" data-id="element-773">
        Returns
      </h2>
      <ul className="space-y-2" data-id="element-774">
        <li data-id="element-775">
          • <strong data-id="element-776">Reply to your confirmation order email</strong> to request a
          return.
        </li>
        <li data-id="element-777">
          • Returns are only on unused, without engravings, with the packaging,{' '}
          <strong data-id="element-778">within 7 days</strong>.
        </li>
        <li data-id="element-779">
          • <strong data-id="element-780">Shipping charges are non-refundable</strong> once an item
          has shipped.
        </li>
        <li data-id="element-781">
          • Approved refunds issued to a <strong data-id="element-782">credit card</strong> are
          subject to a <strong data-id="element-783">5% return/transaction fee</strong>.
        </li>
      </ul>
    </section>;
}